module.exports = require('./lib/axios');


// WEBPACK FOOTER //
// ./~/rp-react-common/~/axios/index.js